<template>
    <svg width="378" height="175" viewBox="0 0 378 175" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
            <path
              d="M297.142 51.6485L288.753 40.413L278.03 48.6001L246.292 73.0744C246.292 73.1223 246.331 73.1615 246.378 73.1615C248.366 77.5538 251.254 81.4723 254.853 84.6583"
              fill="url(#paint0_linear)"
            />
            <path
              d="M128.162 104.516H126.605C117.208 104.432 109.657 96.6907 109.742 87.2259C109.742 87.2119
                109.742 87.198 109.742 87.1841V29.5258H111.299C120.696 29.6102 128.247 37.3514 128.162
                46.8163C128.162 46.8302 128.162 46.8442 128.162 46.8581V104.516Z"
              fill="url(#paint1_linear)"
            />
            <path
              d="M90.2843 18.6388C88.8894 14.7281 86.6781 11.1632 83.7983 8.18713C80.8935 5.24499 77.3799
                2.98395 73.5073 1.56775C70.5255 0.553938 67.4019 0.0243872 64.2541 0H9.84912e-05C-0.0327636
                10.213 8.16199 18.5186 18.3025 18.5517C18.3129 18.5517 18.3233 18.5517 18.3337 18.5517H64.427
                C67.5498 18.6144 70.6094 19.4523 73.3344 20.9904C74.7293 21.8004 76.0092 22.7968 77.1394
                23.9517C84.2887 31.2418 84.2887 42.965 77.1394 50.2551C76.0092 51.41 74.7293 52.4064 73.3344
                53.2164C70.7149 54.7806 67.7323 55.622 64.6865 55.6551C67.6328 55.588 70.5497 55.0594 73.3344
                54.0873C77.2225 52.7042 80.7439 50.4388 83.6254 47.468C86.5415 44.5206 88.7579 40.9479 90.1113
                37.0163C91.1664 34.0254 91.693 30.8707 91.6679 27.6969C91.8158 24.6145 91.3454 21.5339 90.2843
                18.6388Z"
              fill="url(#paint2_linear)"
            />
            <path
              d="M77.3124 24.0389C76.1821 22.884 74.9022 21.8876 73.5073 21.0776C70.8178 19.4454
                67.7409 18.5727 64.6 18.5518C66.9565 18.6293 69.1903 19.6292 70.8265 21.3389C72.5422
                23.1096 73.5038 25.4847 73.5073 27.9583C73.4874 30.4292 72.5275 32.7974 70.8265 34.5776
                C69.1021 36.303 66.7714 37.2733 64.3405 37.2776H27.5869C30.0178 37.282 32.3485 38.2523
                34.0728 39.9777L47.7365 55.7422H64.7729C69.4627 55.6395 73.9293 53.7033 77.2259 50.3422
                C84.3414 43.0522 84.3795 31.3759 77.3124 24.0389Z"
              fill="url(#paint3_radial)"
            />
            <path
              d="M49.6384 55.7421L34.937 40.7614C33.1209 37.8872 36.6666 37.2775 36.6666 37.2775L27.4998
                37.1904C25.0689 37.1948 22.7383 38.165 21.0139 39.8904C19.2981 41.6611 18.3365 44.0363
                18.333 46.5098C18.3529 48.9808 19.3128 51.3489 21.0139 53.1292L23.6947 55.8292L66.5883
                99.1165C73.7332 106.332 85.3335 106.347 92.4975 99.1514C92.5087 99.14 92.5208 99.1279
                92.5321 99.1165L49.6384 55.7421Z"
              fill="url(#paint4_linear)"
            />
            <path
              d="M119.341 24.213C125.98 24.2609 131.4 18.88 131.448 12.1936C131.496 5.50712 126.153
                0.0487371 119.514 -3.72838e-05C112.875 -0.0488117 107.456 5.33292 107.407 12.0194C107.407
                12.0481 107.407 12.0769 107.407 12.1065C107.383 18.7685 112.725 24.1886 119.34 24.213C119.341
                24.213 119.341 24.213 119.341 24.213Z"
              fill="url(#paint5_linear)"
            />
            <path
              d="M246.379 73.1616C246.379 73.1137 246.34 73.0745 246.292 73.0745L243.006 75.6003L251.654 87.1842L254.854 84.6584C251.254 81.4724 248.366 77.5539 246.379 73.1616Z"
              fill="url(#paint6_linear)"
            />
            <path
              d="M303.369 60.6196C290.57 64.8002 289.272 74.1196 289.272 74.1196C288.321 78.3874
                285.813 82.0455 281.749 85.181C276.992 88.8391 271.977 90.4068 266.701 89.7971C262.348
                89.413 258.229 87.6441 254.94 84.7455L254.854 84.6584C251.255 81.4724 248.366 77.5539
                246.379 73.1616C246.379 73.1137 246.34 73.0745 246.292 73.0745C244.731 69.3667 244.251
                65.2889 244.909 61.3164C245.833 56.2029 248.683 51.6468 252.865 48.6002C256.844 45.3279
                261.928 43.7358 267.047 44.1582C271.064 44.5101 274.887 46.0569 278.03 48.6002C278.03
                48.6002 287.802 55.8292 284.343 61.6647L297.142 51.6486L299.304 49.9937L295.412 44.855C288.927
                36.4066 281.057 31.3549 271.804 29.7001C262.032 27.9581 252.865 30.571 244.39 37.1033C235.915
                43.7227 231.158 52.084 230.207 62.0131C229.429 71.5067 232.283 80.6519 238.682 89.0133C245.082
                97.4617 253.038 102.513 262.55 103.994C272.323 105.736 281.576 103.036 290.137 96.4165C296.883
                91.2778 301.207 85.181 303.023 78.5616C304.651 72.7078 304.769 66.5326 303.369 60.6196Z"
              fill="url(#paint7_linear)"
            />
            <path
              d="M333.982 69.5036C332.971 69.5114 331.968 69.3041 331.042 68.8939C327.198 67.2721
                325.386 62.818 326.997 58.9465C327.019 58.8942 327.042 58.8429 327.064 58.7906C329.454
                53.5996 332.97 49.0157 337.355 45.3776C344.014 39.9776 355.429 34.4905 372.466 39.2808C376.47
                40.4009 378.814 44.5772 377.702 48.6098C377.686 48.6647 377.671 48.7196 377.654 48.7744C376.508
                52.8628 372.287 55.2405 368.228 54.0874C359.667 51.6486 352.402 52.6938 346.781 57.31C344.341
                59.348 342.34 61.8677 340.901 64.7132C339.822 67.6144 337.059 69.5279 333.982 69.5036Z"
              fill="url(#paint8_linear)"
            />
            <path
              d="M340.9 104.516H339.257C329.859 104.432 322.309 96.6907 322.393 87.2259C322.393 87.2119
                322.393 87.198 322.393 87.1841V29.5258H323.95C333.348 29.6102 340.898 37.3514 340.813 46.8163C340.813
                46.8302 340.813 46.8442 340.813 46.8581V104.516H340.9Z"
              fill="url(#paint9_linear)"
            />
            <path
              d="M188.178 103.471L188.784 103.21L168.115 41.1969C165.285 32.3879 155.901 27.5583
                147.155 30.4082C147.079 30.4325 147.004 30.4578 146.928 30.4839L146.322 30.7452L166.991
                92.7584C169.679 101.495 178.89 106.383 187.565 103.676C187.771 103.612 187.975 103.544
                188.178 103.471Z"
              fill="url(#paint10_linear)"
            />
            <path
              d="M218.705 30.4842C209.971 27.3487 200.544 32.139 197.518 41.1972L180.395 92.5845C180.308 92.8458
                179.876 93.8038 179.703 94.1522C175.898 101.294 171.314 99.8136 171.314 99.8136C172.889 101.34
                174.738 102.553 176.763 103.385L177.454 103.646C186.189 106.781 195.615 101.904 198.642 92.9329L219.31
                30.9197L218.705 30.4842Z"
              fill="url(#paint11_linear)"
            />
            <path d="M3.8499 152.579V172.055H15.989V174.647H0.996094V152.579H3.8499Z" fill="white" />
            <path d="M25.3587 152.579V174.647H22.5049V152.579H25.3587Z" fill="white" />
            <path d="M34.1391 152.579L40.5057 170.711L46.7789 152.577H49.7581L41.6974 174.645H39.3132L31.1582 152.577L34.1391 152.579Z" fill="white" />
            <path d="M58.1878 162.142H68.6959V164.732H58.1878V172.055H70.4523V174.647H55.334V152.579H70.4523V155.17H58.1878V162.142Z" fill="white" />
            <path
              d="M104.034 174.646H102.967C102.308 174.671 101.653 174.539 101.054 174.262C100.427 173.902 99.8736 173.424 99.4239 172.856L98.8272 172.12C98.0247 
                173.039 97.0492 173.789 95.9578 174.326C94.9573 174.78 93.8711 175.01 92.7737 174.997C91.5967 175.031 90.431 174.761 89.3863 174.214C88.4817 173.728 
                87.7363 172.989 87.2382 172.087C86.1433 169.999 86.2756 167.474 87.5841 165.514C88.4938 164.261 89.6397 163.202 90.9568 162.396C90.2139 161.504 89.567 
                160.533 89.0283 159.502C88.6564 158.763 88.4575 157.947 88.448 157.119C88.4324 156.237 88.6607 155.368 89.107 154.608C89.5523 153.867 90.1932 153.264 
                90.9568 152.866C91.7896 152.43 92.7166 152.21 93.6549 152.226C95.0308 152.169 96.3729 152.664 97.3882 153.602C98.3516 154.523 98.8765 155.815 98.8298 
                157.151C98.8463 158.21 98.515 159.243 97.8889 160.093C97.0207 161.165 95.9812 162.084 94.8146 162.813L94.6581 162.908L99.0183 168.249L101.841 164.891L103.629 
                166.49L100.555 170.136L101.308 171.064C101.585 171.403 101.92 171.69 102.296 171.911C102.643 172.081 103.025 172.162 103.41 172.15H104.037L104.034 
                174.646ZM97.3216 170.265L92.4278 164.255C91.4782 164.856 90.6402 165.619 89.951 166.51C89.4243 167.215 89.1381 168.073 89.1355 168.956C89.1035 169.917 
                89.4659 170.848 90.1387 171.53C90.9049 172.238 91.9236 172.602 92.9613 172.538C93.7301 172.544 94.4894 172.363 95.1735 172.01C95.9812 171.554 96.7068 
                170.964 97.3199 170.265H97.3216ZM91.0796 157.089C91.0865 157.647 91.2257 158.195 91.4869 158.687C91.9245 159.465 92.4286 160.204 92.9942 160.894L93.1507 
                161.085L93.3375 160.957C94.1816 160.448 94.9391 159.805 95.5808 159.054C96.0063 158.501 96.2329 157.819 96.2242 157.12C96.2562 156.415 96.0011 155.728 
                95.5185 155.217C94.5387 154.179 92.9095 154.138 91.8786 155.125C91.3468 155.634 91.0553 156.349 91.0796 157.089Z"
              fill="white"
            />
            <path
              d="M120.645 165.212V161.981C120.645 158.762 121.434 156.338 123.013 154.705C124.592 153.073 126.824 152.258 129.71 152.259C132.574 152.259 134.786 153.074 136.345 154.705C137.904
                156.337 138.682 158.761 138.68 161.981V165.212C138.68 168.431 137.89 170.856 136.311 172.487C134.732 174.118 132.5 174.934 129.614 174.934C126.75 174.934 124.539 174.118
                122.981 172.487C121.424 170.856 120.645 168.431 120.645 165.212ZM135.858 165.243V162.142C135.858 159.645 135.345 157.811 134.32 156.64C133.108 155.391 131.409 154.746
                129.679 154.881C127.588 154.881 126.036 155.467 125.021 156.64C124.007 157.812 123.5 159.646 123.5 162.142V165.243C123.5 167.652 124.007 169.433 125.021 170.584C126.036
                171.735 127.588 172.311 129.679 172.311C131.402 172.446 133.098 171.815 134.32 170.584C135.346 169.433 135.859 167.653 135.859 165.243H135.858Z"
              fill="white"
            />
            <path d="M164.013 174.647H161.16L148.77 157.569V174.647H145.916V152.579H148.77L161.16 169.689V152.579H164.013V174.647Z" fill="white" />
            <path
              d="M189.597 152.579C192.479 152.579 194.707 153.378 196.278 154.977C197.85 156.576
                 198.634 158.965 198.63 162.142V165.051C198.63 168.228 197.84 170.622 196.261 172.232
                 C194.682 173.843 192.44 174.647 189.534 174.647H181.599V152.579H189.597ZM194.254 170.36
                 C195.269 169.231 195.777 167.482 195.776 165.115V162.301C195.776 159.871 195.268 158.075
                 194.254 156.913C193.24 155.751 191.687 155.17 189.597 155.171H184.452V172.056H189.597
                 C191.688 172.055 193.24 171.491 194.254 170.362V170.36Z"
              fill="white"
            />
            <path d="M208.721 162.142H219.229V164.732H208.721V172.055H220.985V174.647H205.867V152.579H220.985V155.17H208.721V162.142Z" fill="white" />
            <path d="M249.146 174.647H246.324V157.952L239.455 170.265H237.447L230.577 157.952V174.647H227.724V152.579H230.577L238.447 166.907L246.317 152.579H249.146V174.647Z" fill="white" />
            <path
              d="M259.641 169.658L257.697 174.647H254.716L263.749 152.579H266.165L275.23 174.647H272.218L270.241
                169.658H259.641ZM264.942 156.158L260.612 167.191H269.269L264.942 156.158Z"
              fill="white"
            />
            <path d="M298.901 174.647H296.047L283.658 157.569V174.647H280.804V152.579H283.658L296.047 169.689V152.579H298.901V174.647Z" fill="white" />
            <path
              d="M314.545 152.579C317.428 152.579 319.654 153.378 321.226 154.977C322.797 156.576
                323.581 158.965 323.578 162.142V165.051C323.578 168.228 322.788 170.622 321.209 172.232C319.63
                173.843 317.388 174.647 314.481 174.647H306.547V152.579H314.545ZM319.201 170.36C320.217
                169.231 320.724 167.482 320.724 165.115V162.301C320.724 159.871 320.217 158.075 319.201 156.913
                C318.186 155.751 316.634 155.17 314.545 155.171H309.401V172.056H314.545C316.636 172.055 318.189
                171.491 319.201 170.362V170.36Z"
              fill="white"
            />
            <path d="M348.531 155.17V174.647H345.708V155.17H338.714V152.579H355.525V155.17H348.531Z" fill="white" />
            <path d="M362.043 152.579L368.409 170.711L374.682 152.577H377.662L369.602 174.645H367.217L359.062 152.577L362.043 152.579Z" fill="white" />
            <path d="M378 129.413H0V130.333H378V129.413Z" fill="url(#paint12_radial)" />
        </g>
        <defs>
            <linearGradient id="paint0_linear" x1="281.856" y1="54.4121" x2="241.404" y2="85.6802" gradientUnits="userSpaceOnUse">
                <stop offset="0.452" stop-color="#28A5DE" />
                <stop offset="0.998" stop-color="#2861AE" />
            </linearGradient>
            <linearGradient id="paint1_linear" x1="118.952" y1="32.2109" x2="118.952" y2="108.397" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint2_linear" x1="1.61017" y1="-3.44496" x2="94.1284" y2="39.7919" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
                <radialGradient id="paint3_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(32.3791 21.5947) rotate(45.1323) scale(85.861 86.3635)">
                    <stop stop-color="#3ABDB1" />
                    <stop offset="0.726" stop-color="#2861AE" />
                </radialGradient>
            <linearGradient id="paint4_linear" x1="23.4307" y1="41.5395" x2="94.3473" y2="107.653" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint5_linear" x1="107.008" y1="2.50871" x2="141.825" y2="29.0652" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint6_linear" x1="293.019" y1="46.1451" x2="240.891" y2="85.7913" gradientUnits="userSpaceOnUse">
                <stop offset="0.452" stop-color="#28A5DE" />
                <stop offset="0.998" stop-color="#2861AE" />
            </linearGradient>
            <linearGradient id="paint7_linear" x1="240.184" y1="95.6701" x2="285.922" y2="47.6416" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="0.771" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint8_linear" x1="375.254" y1="39.0055" x2="335.633" y2="58.8322" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="0.502" stop-color="#28A5DE" />
                <stop offset="0.998" stop-color="#2861AE" />
            </linearGradient>
            <linearGradient id="paint9_linear" x1="331.646" y1="32.2134" x2="331.646" y2="113.386" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint10_linear" x1="150.934" y1="25.6088" x2="185.322" y2="110.041" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="0.599" stop-color="#28A5DE" />
                <stop offset="0.998" stop-color="#2861AE" />
            </linearGradient>
            <linearGradient id="paint11_linear" x1="178.746" y1="115.842" x2="218.778" y2="-4.40076" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="0.563" stop-color="#33AFCA" />
                <stop offset="0.814" stop-color="#28A5DE" />
                <stop offset="0.998" stop-color="#2861AE" />
            </linearGradient>
                <radialGradient id="paint12_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(188.982 129.873) scale(205.354 181.21)">
                    <stop stop-color="#F2F2F2" />
                    <stop offset="0.178" stop-color="#F2F2F2" stop-opacity="0.803" />
                    <stop offset="0.585" stop-color="#F2F2F2" stop-opacity="0.375" />
                    <stop offset="0.868" stop-color="#F2F2F2" stop-opacity="0.105" />
                    <stop offset="1" stop-color="#F2F2F2" stop-opacity="0" />
                </radialGradient>
            <clipPath id="clip0">
                <rect width="378" height="175" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
